import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import StoreInterest from 'lib/flux/store/interest_mixin';
import _ from 'underscore';
import queryString from 'query-string';
import { Theme } from 'ui_system/theme';
import BookingDetailsActionCreator from 'action_creators/booking_details';
import IntegrationActionCreator from 'action_creators/integration';
import NoAvailability from 'views/plugins/tours/page/booking_details/no_availability';
import { FormattedMessage, injectIntl } from 'react-intl';
import { JoinWaitlist } from 'views/plugins/tours/page/booking_details/waitlist/JoinWaitlist';

const MobileRequestButtonComponent = createReactClass({
  displayName: 'MobileRequestButton',
  mixins: [StoreInterest],

  propTypes: {
    context: PropTypes.string.isRequired,
    is_available: PropTypes.bool,
    should_redirect: PropTypes.bool,
    href: PropTypes.string,
    contact_props: PropTypes.object,
    tour_settings: PropTypes.object,
  },

  getDefaultProps() {
    return {
      is_available: true,
      should_redirect: true,
      href: '',
      contact_props: {},
      context: '',
      tour_settings: {},
    };
  },

  getInitialState() {
    return {
      formHidden: true,
      originUrl: null,
    };
  },

  getStoreInterests() {
    return {
      originUrl: 'booking_details.originUrl',
      formHidden: 'booking_details.hidden',
    };
  },

  componentDidMount() {
    IntegrationActionCreator.queryOriginUrl();
  },

  _layoutVariant() {
    if (
      window.matchMedia(
        `only screen and (max-width: ${Theme.mobile.phoneWidth - 1}px)`
      ).matches
    ) {
      return 'tablet';
    }
    return 'desktop';
  },

  onClick(e) {
    if (this.props.is_available) {
      if (!window.mobileDetect.phone()) {
        e.preventDefault();
        this._requestBooking();
      }
    }
  },

  _getPluginParam() {
    // Returns slug of Plugin if in that context
    const currentUrlParsed = window.location.href.split('/');
    const indexOfPlugin = currentUrlParsed.indexOf('plugin');

    if (indexOfPlugin !== -1) {
      return currentUrlParsed[indexOfPlugin + 1];
    }

    return null;
  },

  getLocationParams() {
    const { locationQuery, locationRadius } = queryString.parse(
      window.location.href.split('?')[1]
    );
    if (locationQuery && locationRadius) {
      return { locationQuery, locationRadius };
    }
    return null;
  },

  _requestBooking() {
    const { href, context, should_redirect, intl } = this.props;
    const { originUrl } = this.state;

    const navTo = _.addToURLParams(href, {
      origin_url: originUrl || window.location.href,
      context,
      lang: intl.locale,
      plugin: this._getPluginParam(),
      ...this.getLocationParams(),
    });

    if (this._layoutVariant() === 'tablet') {
      BookingDetailsActionCreator.showForm();
    } else {
      if (should_redirect) {
        IntegrationActionCreator.redirect_to(navTo);
      } else {
        window.location = navTo;
      }
    }
  },

  _mobileRequestHref() {
    const { href, context, intl } = this.props;
    const { originUrl } = this.state;

    if (href) {
      if (window.mobileDetect.phone()) {
        return _.addToURLParams(href, {
          origin_url: originUrl || window.location.href,
          context,
          lang: intl.locale,
          plugin: this._getPluginParam(),
          ...this.getLocationParams(),
        });
      }
      return href;
    }
    return '#';
  },

  _renderNoAvailability() {
    const { contact_props, tour_id, waitlist_details, sold_out_link_text } =
      this.props;
    const { has_available_waitlist_slots, enabled_for_tour, enabled_for_user } =
      waitlist_details || {};
    const showWaitlistContent =
      has_available_waitlist_slots && enabled_for_tour && enabled_for_user;

    if (!this.props.is_available && !showWaitlistContent) {
      return <NoAvailability {...contact_props} />;
    } else if (!this.props.is_available && showWaitlistContent) {
      return (
        <JoinWaitlist
          experienceId={tour_id}
          noAvailability={true}
          userId={contact_props.guide_id}
          soldOutLinkText={sold_out_link_text}
        />
      );
    }
  },

  render() {
    const { tour_settings, is_available, intl } = this.props;
    const { formHidden } = this.state;
    const label = tour_settings?.request_booking_label?.value;
    // The default label is 'Request Booking', but user can customize it with translations in Admin
    const translatedLabel =
      label === 'Request Booking' ? (
        <FormattedMessage
          defaultMessage="Request Booking"
          id="REQUEST_BOOKING"
          description="Button label to request a booking for a tour or experience"
        />
      ) : (
        label || (
          <FormattedMessage
            defaultMessage="Continue to Checkout"
            id="CONTINUE_TO_CHECKOUT"
            description="Button label to proceed to the checkout process"
          />
        )
      );

    if (!formHidden) {
      return null;
    }
    return (
      <div>
        <a
          href={this._mobileRequestHref()}
          className={'ui button brand-bg ' + (is_available ? '' : 'disabled')}
          onClick={this.onClick}
          data-testid="mobile-request-booking"
        >
          {translatedLabel}
        </a>
        {this._renderNoAvailability()}
      </div>
    );
  },
});

const MobileRequestButton = injectIntl(MobileRequestButtonComponent);
export default MobileRequestButton;
